import { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { validation } from '../../validations';
import Step1 from './step1';
import Step2 from './step2';
import { QuizzData } from '../../types';
import { useParams } from "react-router-dom";
import { handleQuizz } from '../../services';
import { links } from '../../constants';
import { Footer, LineBroken } from './style';
import { ZennexuLogo } from '../../assets';
import { useQuizNavigation } from '../../hooks';
import { formatLeadPhone } from '../../utils/phone';

const TOTAL_STEPS = 2;

export default function QuizCar() {
  const { step, goNext, goBack, canGoBack } = useQuizNavigation(TOTAL_STEPS);

  const { reset } = useForm({ resolver: yupResolver(validation) });
  // TODO: add confirm params
  const { slug } = useParams();

  const isFacebook = slug === 'facebook';

  useEffect(() => {
    document.title = 'Quiz | Zennexu';
    const favicon = document.getElementById('favicon') as HTMLLinkElement | null;
    if (favicon) favicon.href = '/Favcon zennexu.png';
  }, []);

  const redirect = (opt: string) => {
    const baseUrl = opt === 'yes'
      ? links.yes
      : (isFacebook ? links.zennexuBlogFacebook : 'https://zennexu.com/lp-comprar-carro-sem-entrada-como-financiar');
    const extraParams = window.location.search.replace(/^\?/, '');
    const url = extraParams
      ? `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}${extraParams}`
      : baseUrl;
    window.open(url, '_self');
  }

  const onSubmitHandler = async (data: QuizzData, isEmailValid?:boolean) => {
    try {
      // links
      const params = new URLSearchParams(window.location.search);
      console.log('params', params);
      const dataformated = {
        source: slug,
        phone: formatLeadPhone(data?.phone),
        email: data.email,
        fullName: data.name,
        utmSource: params.get('utm_source'),
        utmMedium: params.get('utm_medium'),
        utmCampaign: params.get('utm_campaign'),
        random: Math.floor(Math.random() * 10)
      } as any
      
      if(isEmailValid){
        const response: any = await handleQuizz(dataformated);
        if (response?.result) {
          try {
            TagManager.dataLayer({
              dataLayer: {
                event: 'lead',
                data: dataformated,
              }
            });
            // Facebook Pixel - Lead Event
            if (typeof window !== 'undefined' && (window as any).fbq) {
              (window as any).fbq('track', 'Lead');
            }
            console.log('Dados enviados para o TagManager!');
          } catch (error) {
            console.error('Erro ao enviar os dados para o TagManager!');
          }
        }
      }else{
        console.log('Dados não enviados para o TagManager!');
      }
      redirect(data.option||'');
      reset();
    } catch (error:any) {
      redirect(data.option||'');
      console.error('Erro na solicitação!, tente novamente mais tarde!');
    }
  };

  const steps: Record<number, JSX.Element> = {
    1: <Step1 step={step} onClick={goNext} />,
    2: <Step2 step={step} option={``} onSubmit={onSubmitHandler} onBack={canGoBack ? goBack : undefined} />,
  };
  return (
    <>
      {steps[step]}

      <Footer>
        <LineBroken /> 
        <div>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginBottom: 15}}>
          <img src={ZennexuLogo} alt='logo' style={{width: 80, height: 22 }} /> &nbsp; &nbsp; &nbsp;
          ©{new Date().getFullYear()} |  https://zennexu.com Todos os direitos reservado
          </div>
      
          <div style={{marginBottom: 15}}>
          Go Work Digital LTDA | CNPJ: 41.371.213/0001-07 <br/>
          Belo Horizonte - MG - CEP: 30110-005 - Brasil <br/>
          contato@educacity.com.br | +55 79 9 9917-7197
          </div>
          <div>
            <a href={links.privacy} target='_blank' rel='noreferrer'> Políticas de privacidade </a> |
            <a href={links.terms} target='_blank' rel='noreferrer'> Termos de Serviço </a> |
            <a href={links.disclaimer} target='_blank' rel='noreferrer'> Disclaimer </a>
          </div>
       
        </div>
      </Footer>
    </>
  );
}
